import $ from 'jquery';

const SELECTORS = {
    FOLLOWED: {
        CONTAINER: '.cards--shops',
    },
    RECOMMENDED: {
        CONTAINER: '.recommended-shops',
    },
    HOT_LIST: {
        CONTAINER: '.hotlist-shops',
    },
};

$(() => {
    // Execute only if at least one of the container elements exists
    if ($(SELECTORS.FOLLOWED.CONTAINER).length || $(SELECTORS.RECOMMENDED.CONTAINER).length || $(SELECTORS.HOT_LIST.CONTAINER).length) {
        SELECTORS.RECOMMENDED.HEART_ICON = `${SELECTORS.RECOMMENDED.CONTAINER}__favorite`;
        SELECTORS.RECOMMENDED.ACTIVE_CLASS = 'recommended-shops__favorite--active';
        SELECTORS.RECOMMENDED.CAROUSEL_CONTAINER = '.js-carousel-shops';
        SELECTORS.RECOMMENDED.SLICK_CONTAINER = '.slick-slider';
        SELECTORS.RECOMMENDED.SLICK_SLIDE = '.slick-slide';
        SELECTORS.FOLLOWED.CARD_CONTAINER = '.card--shops';
        SELECTORS.FOLLOWED.HEART_ICON = `${SELECTORS.FOLLOWED.CARD_CONTAINER}__header-icon`;
        SELECTORS.HOT_LIST.HEART_ICON = `${SELECTORS.HOT_LIST.CONTAINER}__favorite`;

        addFollowButtonListener();
        addUnfollowButtonListener();
        addHotlistHeartButtonListener();
    }

    function addFollowButtonListener() {
        $(SELECTORS.RECOMMENDED.CAROUSEL_CONTAINER)
            .on('click', SELECTORS.RECOMMENDED.HEART_ICON, handleFollowButtonClick);
    }

    function addUnfollowButtonListener() {
        const $unfollowButtons = $(SELECTORS.FOLLOWED.HEART_ICON);
        $unfollowButtons.each(function() {
            const $unfollowButton = $(this);
            $unfollowButton.on('click', handleUnfollowButtonClick);
        });
    }

    function handleFollowButtonClick() {
        const $followButton = $(this);
        if (!$followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
            $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
            $followButton.prop('disabled', true);
            const data = $.param({
                cplId: $followButton.data('cpl-id'),
                shopId: $followButton.data('shop-id'),
                brand: $followButton.data('brand'),
                isMens: $followButton.data('is-mens'),
                operation: window.rcProps.myShops.myShopAddOperation,
            });
            $.ajax({
                url: window.rcProps.myShops.updateMyShopPath,
                type: 'post',
                data: data,
                success: function (response) {
                    $.modal({
                        open: "my-shop-add-confirm-modal",
                        type: 'notification',
                        triggerOpen: true,
                        returnFocus: '',
                        closeButton: false,
                    });
                    const i = $followButton.closest(SELECTORS.RECOMMENDED.SLICK_SLIDE).data('slick-index');
                    $followButton.closest(SELECTORS.RECOMMENDED.SLICK_CONTAINER).delay(800).slick('slickRemove', i).slick('refresh');
                    location.reload();
                }
            });
        }
    }

    function handleUnfollowButtonClick() {
        const $unfollowButton = $(this);
        $unfollowButton.closest('li').delay(800).remove();
        const data = $.param({
            cplId: $unfollowButton.data('cpl-id'),
            shopId: $unfollowButton.data('shop-id'),
            brand: $unfollowButton.data('brand'),
            isMens: $unfollowButton.data('is-mens'),
            operation: window.rcProps.myShops.myShopRemoveOperation,
        });
        $.ajax({
            url: window.rcProps.myShops.updateMyShopPath,
            type: 'post',
            data: data,
            success: function (response) {
                $.modal({
                    open: "my-shop-remove-confirm-modal",
                    type: 'notification',
                    triggerOpen: true,
                    returnFocus: '',
                    closeButton: false,
                });
                const totalShops = parseInt($('#shops-size').text()) - 1;
                if (totalShops >= 0) {
                    $('#shops-size').text(totalShops);
                }

                const url = new URL(window.location.href);
                const shopsOnPage = $(SELECTORS.FOLLOWED.CARD_CONTAINER).length;
                if (shopsOnPage < 1) {
                    $('.pagination__wrap').hide();
                    let pageNo = url.searchParams.get('pageNum');
                    if (pageNo) {
                        pageNo = parseInt(pageNo) - 1;
                        if (pageNo <= 1) {
                            url.searchParams.delete('pageNum');
                        } else {
                            url.searchParams.set('pageNum', pageNo);
                        }
                    }
                }
              window.location.href = url.href;
            }
        });
    }

    function addHotlistHeartButtonListener() {
        const $heartButtons = $(SELECTORS.HOT_LIST.HEART_ICON);
        $heartButtons.each(function addUnfollow() {
            const $heartButton = $(this);
            $heartButton.on('click', handleHeartButtonClick);
        });
    }

    function handleHeartButtonClick() {
        const $heartButton = $(this);
        if (!$heartButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
            addHearted($heartButton);
        } else {
            removeHearted($heartButton);
        }
    }

    function addHearted($followButton) {
        const data = $.param({
            cplId: $followButton.data('cpl-id'),
            shopId: $followButton.data('shop-id'),
            brand: $followButton.data('brand'),
            isMens: $followButton.data('is-mens'),
            operation: window.rcProps.myShops.myShopAddOperation,
        });
        if ($followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
            return;
        }
        $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
        $.ajax({
            url: window.rcProps.myShops.updateMyShopPath,
            type: 'post',
            data: data,
            success: function () {
                $.modal({
                    open: "my-shop-add-confirm-modal",
                    type: 'notification',
                    triggerOpen: true,
                    closeButton: false,
                });
            }
        });
    }

    function removeHearted($unfollowButton) {
        const data = $.param({
            cplId: $unfollowButton.data('cpl-id'),
            shopId: $unfollowButton.data('shop-id'),
            brand: $unfollowButton.data('brand'),
            isMens: $unfollowButton.data('is-mens'),
            operation: window.rcProps.myShops.myShopRemoveOperation,
        });
        if (!$unfollowButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
            return;
        }
        $unfollowButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
        $.ajax({
            url: window.rcProps.myShops.updateMyShopPath,
            type: 'post',
            data: data,
            success: function () {
                $.modal({
                    open: "my-shop-remove-confirm-modal",
                    type: 'notification',
                    triggerOpen: true,
                    closeButton: false,
                });
            }
        });
    }

});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/follow-shops.js